import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ItemDescriptionsService {
  itemDescriptions;

  constructor(private _http: HttpClient) {}

  public getAllItems() {
    return this._http
      .get('/api/menu-items')
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public updateItem(item) {
    return this._http
      .put('/api/menu-items', item)
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public addItem(item) {
    return this._http
      .post('/api/menu-items', item)
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public removeItem(item) {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: item,
    };

    return this._http
      .delete('/api/menu-items', options)
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  // public getAll() {
  //   this.itemDescriptions = this.db.list('/menuItemDescriptions');
  //   return this.itemDescriptions;
  // }

  // public searchDescriptions(start, end, limit) {
  //   return this.db.list('/menuItemDescriptions', {
  //     query: {
  //       orderByChild: 'name',
  //       limitToFirst: limit,
  //       startAt: start,
  //       endAt: end,
  //     },
  //   });
  // }

  // getFirst() {
  //   this.promos = this.db.list('/promos', {
  //     query: {
  //       limitToLast: 1
  //     }
  //   });
  //   return this.promos;
  // }

  // add(item) {
  //   this.db.list('/menuItemDescriptions').push(item);
  // }

  // update(item) {
  //   let key = item.$key;
  //   this.db
  //     .list('/menuItemDescriptions')
  //     .update(key, item)
  //     .then(result => {})
  //     .catch(error => {
  //       console.log('could not update the item', error);
  //     });
  // }

  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/item-descriptions/item-descriptions.service.ts